import { toast } from "react-toastify";
import {
  AUTH_API_BASE_URL,
  privateAxios,
} from "../../../config/apiConfig";
import {
  ADD_ITEM_TO_CART_FAILURE,
  ADD_ITEM_TO_CART_REQUEST,
  ADD_ITEM_TO_CART_SUCCESS,
  GET_CART_FAILURE,
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
  REMOVE_CART_ITEM_FAILURE,
  REMOVE_CART_ITEM_REQUEST,
  REMOVE_CART_ITEM_SUCCESS,
  UPDATE_CART_ITEM_FAILURE,
  UPDATE_CART_ITEM_REQUEST,
  UPDATE_CART_ITEM_SUCCESS,
  APPLY_COINS_CART_FAILURE,
  APPLY_COINS_CART_REQUEST,
  APPLY_COUPON_CART_FAILURE,
  APPLY_COUPON_CART_REQUEST,
  FIND_CART_BY_ID_REQUEST, FIND_CART_BY_ID_SUCCESS, FIND_CART_BY_ID_FAILURE,
  APPLY_COUPON_CART_SUCCESS,
  SET_BUY_NOW_CHECKOUT,
  CLEAR_BUY_NOW_CHECKOUT
} from "./ActionType";
import { GET_USER_SUCCESS } from "../Auth/ActionType";
import axios from "axios";

const jwt = localStorage.getItem("jwt")

export const getCart = () => async (dispatch) => {
  dispatch({ type: GET_CART_REQUEST });

  try {
    const response = await privateAxios.get(`user/cart`);
    dispatch({ type: GET_CART_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: GET_CART_FAILURE, payload: error.message });
  }
};

export const getCartById = (id) => async (dispatch) => {
  dispatch({ type: FIND_CART_BY_ID_REQUEST });

  try {
    const response = await privateAxios.get(`user/cart/${id}`);
    dispatch({ type: FIND_CART_BY_ID_SUCCESS, payload: response.data });

  } catch (error) {
    dispatch({ type: FIND_CART_BY_ID_FAILURE, payload: error.message });
  }
};

const BUY_NOW_ACTIVE_KEY = "buyNowActive";
const BUY_NOW_SNAPSHOT_KEY = "buyNowCartSnapshot";

const snapshotCartItems = (items = [], selectedCurrency) =>
  (items || [])
    .map((item) => ({
      productId: item.product?.id,
      variantId: item.variant?.id,
      size: item.size || item.variant?.size?.name,
      color: item.color || item.variant?.productColor?.color?.name,
      quantity: item.quantity || 1,
      customerPriceWithCharge: item.customerPriceWithCharge ?? item.variant?.customerPrice,
      selectedCurrency: item.selectedCurrency || selectedCurrency,
    }))
    .filter((item) => item.productId && item.variantId);

const clearBuyNowSession = () => {
  sessionStorage.removeItem(BUY_NOW_ACTIVE_KEY);
  sessionStorage.removeItem(BUY_NOW_SNAPSHOT_KEY);
};

export const isBuyNowCheckoutActive = () => sessionStorage.getItem(BUY_NOW_ACTIVE_KEY) === "1";

export const getBuyNowBagItemCount = () => {
  try {
    if (!isBuyNowCheckoutActive()) {
      return 0;
    }
    return JSON.parse(sessionStorage.getItem(BUY_NOW_SNAPSHOT_KEY) || "[]").length;
  } catch (error) {
    return 0;
  }
};

export const addItemToCart = (productId, variantId, reqData, navigate) => async (dispatch) => {
  dispatch({ type: ADD_ITEM_TO_CART_REQUEST });

  try {
    const response = await privateAxios.post(
      `user/cart/add/product/${productId}/variant/${variantId}`,
      reqData
    );
    if (response?.data?.status === "SUCCESS") {
      dispatch({ type: ADD_ITEM_TO_CART_SUCCESS, payload: response?.data?.response });
      navigate("/cart")
      dispatch(getCart())
    }
  } catch (error) {
    if (error?.response?.data?.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: ADD_ITEM_TO_CART_FAILURE, payload: error.message });
  }
};

export const restoreBuyNowCartSnapshot = () => async (dispatch) => {
  if (!isBuyNowCheckoutActive()) {
    return;
  }

  const snapshot = JSON.parse(sessionStorage.getItem(BUY_NOW_SNAPSHOT_KEY) || "[]");

  try {
    const cartRes = await privateAxios.get(`user/cart`);
    const currentItems = cartRes.data?.cartItems || [];
    for (const item of currentItems) {
      if (item?.id) {
        await privateAxios.delete(`user/cartItem/${item.id}`);
      }
    }

    for (const item of snapshot) {
      await privateAxios.post(
        `user/cart/add/product/${item.productId}/variant/${item.variantId}`,
        {
          size: item.size,
          color: item.color,
          quantity: item.quantity || 1,
          customerPriceWithCharge: item.customerPriceWithCharge,
          selectedCurrency: item.selectedCurrency,
        }
      );
    }

    clearBuyNowSession();
    dispatch({ type: CLEAR_BUY_NOW_CHECKOUT });
    dispatch(getCart());
  } catch (error) {
    clearBuyNowSession();
    dispatch({ type: CLEAR_BUY_NOW_CHECKOUT });
    dispatch(getCart());
  }
};

export const buyNowItem = (productId, variantId, reqData, navigate) => async (dispatch) => {
  dispatch({ type: ADD_ITEM_TO_CART_REQUEST });

  try {
    const cartRes = await privateAxios.get(`user/cart`);
    const existingItems = cartRes.data?.cartItems || [];
    const snapshot = snapshotCartItems(existingItems, reqData?.selectedCurrency);
    sessionStorage.setItem(BUY_NOW_SNAPSHOT_KEY, JSON.stringify(snapshot));
    sessionStorage.setItem(BUY_NOW_ACTIVE_KEY, "1");
    dispatch({ type: SET_BUY_NOW_CHECKOUT, payload: snapshot.length });

    for (const item of existingItems) {
      if (item?.id) {
        await privateAxios.delete(`user/cartItem/${item.id}`);
      }
    }

    const response = await privateAxios.post(
      `user/cart/add/product/${productId}/variant/${variantId}`,
      reqData
    );

    if (response?.data?.status === "SUCCESS") {
      dispatch({ type: ADD_ITEM_TO_CART_SUCCESS, payload: response?.data?.response });
      const latestCart = await privateAxios.get(`user/cart`);
      dispatch({ type: GET_CART_SUCCESS, payload: latestCart.data });
      navigate("/cart/checkout", { state: { id: latestCart.data?.id, buyNow: true } });
    } else {
      await dispatch(restoreBuyNowCartSnapshot());
      dispatch({ type: ADD_ITEM_TO_CART_FAILURE, payload: "Buy now failed" });
    }
  } catch (error) {
    if (error?.response?.data?.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    await dispatch(restoreBuyNowCartSnapshot());
    dispatch({ type: ADD_ITEM_TO_CART_FAILURE, payload: error.message });
  }
};

export const removeCartItem = (cartItemId) => async (dispatch) => {
  dispatch({ type: REMOVE_CART_ITEM_REQUEST });

  try {
    const response = await privateAxios.delete(`user/cartItem/${cartItemId}`);
    if (response?.data?.status === "SUCCESS") {
      dispatch({ type: REMOVE_CART_ITEM_SUCCESS, payload: cartItemId });
      dispatch(getCart())
    }
  } catch (error) {
    if (error?.response?.data?.status === "FAIL") {
      // toast.error(error.response.data.response);
    }
    dispatch({ type: REMOVE_CART_ITEM_FAILURE, payload: error.message });
  }
};

export const updateCartItem = (reqData) => async (dispatch) => {
  dispatch({ type: UPDATE_CART_ITEM_REQUEST });

  try {
    const response = await privateAxios.put(
      `user/cartItem/${reqData.cartItemId}`,
      reqData.data
    );
    if (response?.data?.status === "SUCCESS") {
      dispatch({ type: UPDATE_CART_ITEM_SUCCESS, payload: response.data });
      dispatch(getCart())
    }

  } catch (error) {
    if (error.response.data.status === "FAIL") {
      // toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_CART_ITEM_FAILURE, payload: error.message });
  }
};

export const applyCoinsInCart = (useCoins) => async (dispatch) => {
  dispatch({ type: APPLY_COINS_CART_REQUEST });

  try {
    const response = await privateAxios.put(
      `user/cart/coin/${useCoins}`
    );
    if (response?.data?.status === "SUCCESS") {
      dispatch({ type: GET_CART_SUCCESS, payload: response.data.response });
      const res = await axios.get(`${AUTH_API_BASE_URL}profile`, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      });
      const user = res?.data;
      dispatch({ type: GET_USER_SUCCESS, payload: user });
    }

  } catch (error) {
    if (error.response.data.status === "FAIL") {
      // toast.error(error.response.data.response);
    }
    dispatch({ type: APPLY_COINS_CART_FAILURE, payload: error.message });
  }
};

export const applyCouponInCart = (couponCode, setIsCouponApply) => async (dispatch) => {
  dispatch({ type: APPLY_COUPON_CART_REQUEST });

  try {
    const response = await privateAxios.put(
      `user/cart/coupon/${couponCode}`
    );
    if (response?.data?.status === "SUCCESS") {
      dispatch({ type: APPLY_COUPON_CART_SUCCESS, payload: response.data.response });
      setIsCouponApply(true);
      // const res = await axios.get(`${AUTH_API_BASE_URL}profile`, {
      //   headers: {
      //     Authorization: `Bearer ${jwt}`
      //   }
      // });
      // const user = res?.data;
      // dispatch({ type: GET_USER_SUCCESS, payload: user });
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: APPLY_COUPON_CART_FAILURE, payload: error.message });
  }
};
